/**
 * @member {Number} id
 * @member {String} name
 * @member {('permanent'|'one'|'all'|null)} time_type
 * @member {String} time_of
 * @member {String} time_to
 * @member {Number} sort
 * @member {Boolean} fixed
 */
export default class PassAccessDto {
  id
  name
  time_type
  time_of
  time_to
  sort
  fixed

  /**
   * @param {Number} id
   * @param {String} name
   * @param {('permanent'|'one'|'all'|null)} time_type
   * @param {String} time_of
   * @param {String} time_to
   * @param {Number} sort
   * @param {Boolean} fixed
   */
  constructor({
    id,
    name,
    time_type,
    time_of,
    time_to,
    sort,
    fixed
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    if (!['permanent', 'one', 'all', null].includes(time_type)) {
      throw Error('Wrong \'time_type\' parameter for \'PassAccessDto\'')
    }

    id = id ? Number(id) : -1
    name = String(name)
    time_of = String(time_of)
    time_to = String(time_to)
    sort = sort ? Number(sort) : 0
    fixed = Boolean(fixed)

    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties))
    Object.defineProperty(this, 'name', Object.assign({ value: name }, properties))
    Object.defineProperty(this, 'time_type', Object.assign({ value: time_type }, properties))
    Object.defineProperty(this, 'time_of', Object.assign({ value: time_of }, properties))
    Object.defineProperty(this, 'time_to', Object.assign({ value: time_to }, properties))
    Object.defineProperty(this, 'sort', Object.assign({ value: sort }, properties))
    Object.defineProperty(this, 'fixed', Object.assign({ value: fixed }, properties))

    Object.freeze(this)
  }
}
